const candidateReminderTestIDs = {
  dateInputLabel: 'date-input-label',
  timeInputLabel: 'time-input-label',
  repeatInputLabel: 'repeat-input-label',
  repeatModal: 'repeat-modal',
  repeatModalHeader: 'repeat-modal-header',
  dateLabel: 'date-label',
  repeatLabel: 'repeat-label',
  checkOffCheckbox: 'checkbox',
  reminderTouchableArea: 'reminder-touchable-area',
  checkedInReminderView: 'checked-in-reminder',
  checkInReminderView: 'check-in-reminder',
  addReminderButton: 'add-reminder-button',
  deleteReminderButton: 'delete-reminder-button',
  deleteReminderButtonLabel: 'delete-reminder-button-label',
  ReminderTitle: 'reminder-title',
  saveButton: 'saveButton',
  saveButtonLabel: 'save-button-label',
  datePicker: 'datePicker',
  timePicker: 'timePicker',
  repeatPicker: 'repeatPicker',
  repeatField: 'repeatField',
  dateTextField: 'dateFieldText',
  timeField: 'timeField',
  timeTextField: 'timeFieldText',
  dateField: 'dateField',
  repeatTextField: 'repeatFieldText',
  radioButton: 'radioButton',
  endDateField: 'end-date-field',
  endDateFieldLabel: 'end-date-field-label',
  endDateButton: 'end-date-button',
  endDateButtonLabel: 'end-date-button-label',
  endDateTextField: 'endDateFieldText',
  doneButton: 'done-button',
  // check in reminder section on profile
  addReminderButtonLabel: 'add-reminder-button-label',
};
export default candidateReminderTestIDs;
